import { memo } from "react";

// Components
import { TableSearch } from "ui/components/Table/TableSearch";

// Constants
import { initialDataWithPagination } from "services/api/consts";
import { CALCULATION_TEHNICAL_INSPECTION_SEARCH_COLUMNS } from "./consts";

// Types
import { TehnicalInspectionSearchResultsProps } from "./types";


const TehnicalInspectionSearchResults: React.FC<TehnicalInspectionSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={CALCULATION_TEHNICAL_INSPECTION_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(TehnicalInspectionSearchResults);
